export default __webpack_public_path__ + "static/media/value-social-impact.61d8d94f.svg";